import React from "react";
import { Auth, Hub } from "aws-amplify";
import { Link, withRouter } from "react-router-dom";
import qs from "query-string";
import { Form, Icon, Input, Button, message } from "antd";
const FormItem = Form.Item;

class SignInForm extends React.Component {
  state = {
    loading: false
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { username, password } = values;
        Auth.signIn(username, password)
          .then(user => {
            this.handleSignInResponse(user);
            message.success("¡Bienvenido de vuelta!");
          })
          .catch(err => {
            this.handleSignInErrors(err);
            this.setState({ loading: false });
          });
      } else {
        console.log(err);
        this.setState({ loading: false });
      }
    });
  };

  handleSignInResponse = user => {
    const { history, location } = this.props;
    const locationFrom = location && location.from && location.from.pathname;
    const from = locationFrom || "/";

    switch (user.challengeName) {
      case "NEW_PASSWORD_REQUIRED":
        Hub.dispatch(
          "auth",
          { event: "new_password_required", data: user },
          "SignIn"
        );
        history.push({
          pathname: "/signin",
          search: qs.stringify({ step: "new-password" })
        });
        break;
      default:
        history.push(from);
        break;
    }
  };

  handleSignInErrors = error => {
    switch (error.code) {
      case "UserNotConfirmedException":
        console.log(error.message);
        break;
      case "UserNotFoundException":
        console.log(error.message);
        break;
      case "NotAuthorizedException":
        message.error("Nombre de usuario o contraseña incorrecta.");
        break;
      default:
        console.log(error);
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <FormItem>
          {getFieldDecorator("username", {
            rules: [{ required: true, message: "Ingresa tu usuario!" }]
          })(
            <Input
              prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Usuario"
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("password", {
            rules: [{ required: true, message: "Ingresa tu contraseña!" }]
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
              type="password"
              placeholder="Contraseña"
            />
          )}
        </FormItem>
        <FormItem>
          <Link className="login-form-forgot" to="/forgot-password">
            Recuperar contraseña
          </Link>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            loading={this.state.loading}
          >
            Iniciar Sesión
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default withRouter(Form.create()(SignInForm));



// WEBPACK FOOTER //
// ./src/Components/SignIn/SignInForm.js